import { GeckoAssetHealthPlan } from 'types'

/**
 * Handles toggling preferred status of a plan, ensuring only one plan is preferred at a time
 * @param planId - ID of the plan to toggle
 * @param plans - Array of all plans
 * @param onPlanEdit - Function to edit a plan
 * @returns Promise that resolves when all updates are complete
 */
export const handlePreferredPlanToggle = async (
  planId: string,
  plans: GeckoAssetHealthPlan[],
  onPlanEdit: (
    planId: string,
    updates: Partial<GeckoAssetHealthPlan['data']>
  ) => Promise<void>
): Promise<void> => {
  const plan = plans.find((p) => p.id === planId)
  const currentPreferred = plan?.data.preferred || false

  if (currentPreferred) {
    // If currently preferred, just unset it
    await onPlanEdit(planId, { preferred: false })
  } else {
    // If not preferred, set it as preferred and unset all others in batch
    const otherPreferredPlans = plans.filter(
      (p) => p.id !== planId && p.data.preferred
    )

    // Batch all updates to reduce re-renders and improve performance
    const updates = Promise.all([
      ...otherPreferredPlans.map((otherPlan) =>
        onPlanEdit(otherPlan.id, { preferred: false })
      ),
      onPlanEdit(planId, { preferred: true }),
    ])

    await updates
  }
}
